import {
    AppBar, Backdrop, Box, Button, Dialog, DialogContent, IconButton, Link, Paper, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Toolbar, Typography,
} from "@material-ui/core";
import moment from "moment";
import React, { useState } from "react";
import { PuffLoader } from "react-spinners";
import { useStyles } from "./ClientPlacementHistoryCss";
import { usePost } from "../../../utils/apiHelper";
import CloseIcon from "@material-ui/icons/Close";
import { ARMLogo } from "../../../constants/Constant";
import HistoryIcon from "@mui/icons-material/History";
import { useGlobalState } from "../../../store/GlobalStore";
import { Transition } from "../../GlobalStyles/DialogBoxTransition";
import { IGetClientPlacementTemplateHistory, IGetPlacementTemplateHistoryMaster } from "../../../models/accesscontrol/IClientPlacementContext";
import { IAllTemplateList } from "../../../models/Admin/ClientPlacements/IAllTemplateList";
import { DialogTitleHeader } from "../../GlobalStyles/DialogStyle";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import StyledTableRow from "../../GlobalStyles/StyledTableRow";

const ClientPlacementTemplateHistory: React.FC<{ userRow: IAllTemplateList }> = (props) => {
    const { userRow } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const [clientPlacementHistory, setClientPlacementHistory] = useState<IGetPlacementTemplateHistoryMaster[]>([]);
    const [getClientPlacementTemplateHistory, setGetClientPlacementTemplateHistory] = useState<IGetClientPlacementTemplateHistory[]>([]);
    const [ProgressBar, setShowProgressBar] = useState(false);
    const { state } = useGlobalState();
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        getProspectHistory();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDialogBox = () => {
        setDialogOpen(false);
    }

    const getProspectHistory = () => {
        setShowProgressBar(true);
        (async () => {
            let request = {
                "placementTemplateId": userRow?.placement_template_id,
            };
            await usePost<IGetPlacementTemplateHistoryMaster[]>("History/GetPlacementTemplateHistoryMaster", request).then((GetAllUsersHistory) => {
                setClientPlacementHistory(GetAllUsersHistory?.data);
            }).finally(() => {
                setShowProgressBar(false);
            });
        })();
    };


    const handleViewDetails = (HistoryId: any) => {
        setShowProgressBar(true);
        (async () => {
            let request = {
                "placementTemplatesHistoryId": HistoryId,
            };
            await usePost<IGetClientPlacementTemplateHistory[]>("History/GetClientPlacementTemplateHistory", request).then((GetAllUsersHistory) => {
                setGetClientPlacementTemplateHistory(GetAllUsersHistory?.data);
            }).finally(() => {
                setShowProgressBar(false);
                setDialogOpen(true);
            });
        })();
    }

    function EnhancedTable(props) {
        const { classes } = props;

        const headCells = [
            { id: "templateName", numeric: false, disablePadding: false, label: "FIELD NAME", sortable: true },
            { id: "oldClientCode", numeric: false, disablePadding: false, label: "PERMITTED", sortable: true },
            { id: "newClientCode", numeric: false, disablePadding: false, label: "REQUIRED", sortable: true },
        ];

        return (
            <TableHead>
                <TableRow>
                    {headCells.map(headCell => (
                        <TableCell key={headCell.id} id="CPO_TableHeader" className={classes.TableCellStyle}>
                            {headCell.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    function EnhancedTableHead(props) {
        const { classes, order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        const headCells = [
            { id: "fieldName", disablePadding: false, label: "TEMPLATE NAME", sortable: false, },
            { id: "actionTakenBy", disablePadding: false, label: "ACTION TAKEN BY", sortable: false },
            { id: "actionTakenDate", disablePadding: false, label: "ACTION TAKEN DATE", sortable: false },
            { id: "viewDetails", disablePadding: false, label: "VIEW DETAILS", sortable: false },
        ];

        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} className={classes.TableCellStyle} >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label || headCell.sortable}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    return (
        <div>
            <IconButton style={{ padding: "5px",paddingLeft:'25px' }} onClick={handleClickOpen}>
                <HistoryIcon style={{ color: "#B30987" }} />
            </IconButton>

            <Dialog fullScreen className={classes.dialog} open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar className={classes.toolbarStyle}>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" >
                            <img alt="ARM_Solutions" className={classes.menuButton1} src={ARMLogo} />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            <b> TEMPLATE FIELD HISTORY ({userRow?.name})</b>
                        </Typography>
                        <IconButton edge="end" color="inherit" onClick={() => setOpen(false)} aria-label="close" style={{ padding: '5px' }}>
                            <CloseIcon className={classes.closeIconButton} />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Backdrop className={classes.backdrop} open={ProgressBar}>
                    <PuffLoader size={80} color={"white"} speedMultiplier={1} />
                </Backdrop>
                <DialogContent>
                    <TableContainer component={Paper} className={`${classes.tablebody1} ${"scrollbox"} ${"on-scrollbar"}`} >
                        <Table size="small" aria-label="customized table" stickyHeader>
                            <EnhancedTableHead classes={classes} />
                            {clientPlacementHistory?.map((row) => (
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.templateName}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <span className={classes.tableCellFontSize}>
                                                {row?.modifiedBy}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" className={classes.tableCellFontSize}>
                                                {moment(row?.modifiedDate)?.format(state?.GlobalUtils?.settingValue)}{" "}
                                                {moment(row?.modifiedDate).format("HH:mm:ss")}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Link
                                                component="button"
                                                onClick={() => handleViewDetails(row?.placementTemplatesHistoryId)}
                                                underline="always"
                                                color="primary"
                                                className={classes.tableCellFontSize}
                                            >
                                                View Details
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ))}
                        </Table>
                        {!clientPlacementHistory.length && !ProgressBar ?
                            <Typography variant="h6" align='center' gutterBottom className={classes.ErrorMessageStyle1}>
                                No history to display..
                            </Typography> : null}
                    </TableContainer>
                </DialogContent>
            </Dialog>

            <Dialog TransitionComponent={Transition} open={dialogOpen}
                className={classes.dialogboxOverride}
                PaperProps={{ style: { borderRadius: 15 } }}
                maxWidth={'sm'}
                aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleCloseDialogBox}>
                    <Typography variant="h6" gutterBottom className={classes.titleheader}>
                        TEMPLATE FIELD DETAILS
                    </Typography>
                </DialogTitleHeader>
                <DialogContent >
                    <TableContainer component={Paper} className={`${classes.tablebody2} ${"scrollbox"} ${"on-scrollbar"}`}>
                        <Table aria-label="customized table" size="small" stickyHeader>
                            <EnhancedTable classes={classes} />
                            <TableBody>
                                {getClientPlacementTemplateHistory?.map((row, index) => (
                                    <StyledTableRow key={index}>
                                        <TableCell align="left" className={classes.TableCellStyle1}>
                                            {row?.fieldName}
                                        </TableCell>
                                        <TableCell align="left" className={classes.TableCellStyle1}>
                                            {!row?.fieldName?.includes("Required") ? (
                                                row?.oldFieldValue ? "Added" : "Removed"
                                            ) : null}
                                        </TableCell>
                                        <TableCell align="left" className={classes.TableCellStyle1}>
                                            {row?.fieldName?.includes("Required") ? (
                                                row?.newFieldValue ? "Added" : "Removed"
                                            ) : null}
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <Box display="flex" alignItems="right" justifyContent="right" className={classes.dialogaction}>
                    <Button id="IM_ok_btn" size="small" startIcon={<CheckCircleIcon />} variant="contained" className={classes.yesButton} onClick={() => { setDialogOpen(false); }}>
                        Cancel
                    </Button>
                </Box>
            </Dialog>
        </div >
    )
}

export default ClientPlacementTemplateHistory